import {Button, Card, CardBody, CardFooter, CardHeader, Input, Textarea, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import SelectInput from "../system/select";
import {getPersonsNameAndFamily} from "../../services/profile/profile";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {updateAdminServiceChangePersonWalletBalance} from "../../services/admin_service/change_wallet_balance";
import {Toaster} from "../../helper/Toaster";
import {getPersonWalletBalanceByPersonId} from "../../services/payment/payment";


export function ChangeWalletBalance() {

  const [personId, setPersonId] = useState(null);
  const [operationType, setOperationType] = useState("decrease");
  const [value, setValue] = useState(10000);
  const [description, setDescription] = useState("");
  const [personWalletBalance, setPersonWalletBalance] = useState(null);

  const [buttonLoading, setButtonLoading] = useState(false);

  async function getData(personId) {
    const result = await getPersonWalletBalanceByPersonId(personId);
    if (result.status === 200) {
      const {person_wallet_balance} = result.data;
      setPersonWalletBalance(person_wallet_balance || []);
    }
  }

  const save = async () => {
    if (buttonLoading) return; // Prevent multiple simultaneous requests
    
    if (!personId) {
      Toaster.failure(null,
        <Typography variant={"small"}>
          لطفاْ کاربر مورد نظر را انتخاب فرمایید.
        </Typography>);
      return
    }

    const data = {
      person_id: personId,
      operation_type: operationType,
      value: value,
      description: description,
    };
    
    try {
      setButtonLoading(true);
      let result = await updateAdminServiceChangePersonWalletBalance(data);

      if (result.status === 200) {
        const {new_balance} = result.data;
        setPersonWalletBalance(new_balance);
        setDescription("");
        setValue(10000);
      } else {
        Toaster.failure(null, <Typography variant="small">
          {result.data?.message || 'خطا در تغییر اعتبار'}
        </Typography>);
      }
    } catch (err) {
      Toaster.failure(null, <Typography variant="small">
        {err.message || 'خطا در تغییر اعتبار'}
      </Typography>);
      console.error('Change wallet balance error:', err);
    } finally {
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    if (personId) {
      getData(personId);
    }
  }, [personId]);

  return (
    <div className="mr-8 md:w-1/2">
      <Card className="pt-8">
        <CardHeader floated={true} shadow={false} className="rounded-none">
          <div className="mb-8 flex text-center items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">تغییر اعتبار</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          <div className="grid grid-cols-1 gap-8">

            <div className="flex w-full">
              <SelectInput
                label={"کاربر"}
                defaultValue={personId}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family, phone}) => {
                  const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                  return fullName + " - " + phone
                }}
                onChange={setPersonId}
              />
            </div>


            <div className="flex w-full">
              {personWalletBalance &&
                <Typography>
                  {`موجودی کاربر: ${persianNumberFormat(personWalletBalance, true)} ریال`}
                </Typography>
              }
            </div>

            <div className="flex w-full">
              <SelectInput
                label="نوع تغییر"
                defaultValue={operationType}
                options={[
                  {
                    "id": "increase",
                    "title": "افزایش اعتبار"
                  },
                  {
                    "id": "decrease",
                    "title": "کاهش اعتبار"
                  },
                ]}
                onChange={setOperationType}
              />
            </div>

            <div className="flex w-full mb-2">
              <Input
                label="مبلغ (ریال)"
                type="number"
                variant="standard"
                step="5"
                min={"10000"}
                value={value}
                onChange={(e) => {
                  setValue(parseInt(e.target.value));
                }}
              />
            </div>

            <div className="flex w-full">
              <Typography>
                {`مبلغ: ${persianNumberFormat(value, true)} ریال`}
              </Typography>
            </div>

            <div className="flex w-full">
              <Textarea
                label="دلیل تغییر اعتبار"
                type="number"
                variant="standard"
                step="5"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
            </div>


          </div>
        </CardBody>

        <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Button variant="gradient" color="gray" disabled={buttonLoading} loading={buttonLoading} onClick={save}
                  className="ml-1">
            {buttonLoading ? 'در حال تغییر...' : 'تغییر اعتبار'}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}